// https://vuex.vuejs.org/en/getters.html

export default {
  /// returns true if the user is any of the roles, or if no roles are specified
  userHasAccess: state => roles => {
    if (!roles) {
      return true
    }
    for (var i = 0; i < roles.length; i++) {
      if (!!state.user &&
        !!state.user.profile &&
        !!state.user.profile.role &&
        (
        (Array.isArray(state.user.profile.role) && state.user.profile.role.some(r => r === roles[i])) ||
          state.user.profile.role === roles[i]
        )
      ) {
        return true
      }
    }
    return false
  },
}
